import React, {useState,useEffect, useRef} from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from "react-router-dom";
import { CircularProgress   , Box, Stack,Alert,Button,Grid,Chip,
    Divider,Tooltip,TextField,Select, Autocomplete,Radio,RadioGroup,FormControlLabel,Checkbox,
    FormControl,MenuItem, InputAdornment } from '@mui/material';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
    CloseSharp as CloseSharpIcon,
    ArrowBackIosNewSharp as ArrowBackIosNewSharpIcon,
    ArrowForwardIosSharp as ArrowForwardIosOutlinedIcon,
    CheckSharp as CheckSharpIcon,
    CloudUploadOutlined as CloudUploadOutlinedIcon,
    FileDownloadOutlined as FileDownloadOutlinedIcon,
    KeyboardArrowDown as KeyboardArrowDownIcon,
    KeyboardArrowUp as KeyboardArrowUpIcon,
    Label
}
from '@mui/icons-material';
import { getPropertyInfo, updateAppState } from '../../../actions/appstate';
import { getData365 } from '../../DailyFlash/functions';
import dataService from '../../../services/data.service';
import { deepCopy, getTransformedSegments,generateTableHead, clearAPIRegistryData,
    safeReference, isEmptyObj,cleanIDB } from "../../../app/util";
import { getPricingDataFormatted } from '../../DynamicTable/tilesData/pricing';
import { UPDATE_STATE } from "../../../actions/types";
import { APP_CACHE } from '../../../app/config';
import moment from "moment";
import CustomCalendar from "../../CustomCalendar";
import SendPricingRateBulk from "../../Modal/SendPricingRateBulk";
import '../style.css'; 
const unsavedAlertMsg = "Please save your changes to continume";

const customInfoIcon = (
    <svg
        className='info-icon'
        xmlns="http://www.w3.org/2000/svg"
        width="13" height="13" fill="#606060"
        viewBox="0 0 256 256"
    >
        <path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm16-40a8,8,0,0,1-8,8,16,16,0,0,1-16-16V128a8,8,0,0,1,0-16,16,16,0,0,1,16,16v40A8,8,0,0,1,144,176ZM112,84a12,12,0,1,1,12,12A12,12,0,0,1,112,84Z"></path>
    </svg>
);
const customTickIcon = (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15"
        height="15"
        fill="#606060"
        viewBox="0 0 256 256"
    >
        <path d="M232.49,80.49l-128,128a12,12,0,0,1-17,0l-56-56a12,12,0,1,1,17-17L96,183,215.51,63.51a12,12,0,0,1,17,17Z"></path>
    </svg>
);
const customChipDeleteIcon = (
    <svg className="custom-chip-delete-icon" xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="#606060" viewBox="0 0 256 256"><path d="M165.66,101.66,139.31,128l26.35,26.34a8,8,0,0,1-11.32,11.32L128,139.31l-26.34,26.35a8,8,0,0,1-11.32-11.32L116.69,128,90.34,101.66a8,8,0,0,1,11.32-11.32L128,116.69l26.34-26.35a8,8,0,0,1,11.32,11.32ZM232,128A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z"></path></svg>
)
function BulkPricingSection() {
    const dispatch = useDispatch();
    const blankRestriction = { cta: false, ctd: false, close: false, min_los:null, max_los:null, };
    const {auth} = useSelector(appState => appState);
    const { user, profile } = auth;
    const { user_login_type } = user;
    const { app_state, ui_state } = useSelector((state) => state.app.current_state);
    const [compState, setcompState] = useState({ restrictionOpen: false, 
        entryFields: [], entry: {...blankRestriction}, progress:"loaded",saveReady:false,
        modified: false });
    const selectedCalendarDates = useRef([]);
    const ratePricing = useRef([]);
    const property_info = getPropertyInfo(auth.profile.property_details, app_state.property_id);
    const {market_segment_category_mapping, market_segment_category_order,market_code_ignorelist
    } = property_info.system_settings[0];
    let type = "pricing";
  
    const hasExceptions = (property_info.permissions.restriction_exception === 1);
    // const [dateRange, setDateRange] = useState();
    const    dateRange = useRef({date_from:app_state.as_of_date, 
        date_until:moment(app_state.as_of_date).add(89,"days").format("YYYY-MM-DD")})
    const [dataLevel, setDataLevel] = useState("Hotel");
    const [categoryList, setCategoryList] = useState([]);
    const [dataLvlOptions, setDataLvlOptions] = useState([]);
    const [segmentOptions, setSegmentOptions] = useState([])
    const [ratePlanOptions, setRatePlanOptions] = useState([])
    const [selectedRoomClasses, setSelectedRoomClasses] = useState([])
    const [selectedRoomCodes, setSelectedRoomCodes] = useState([])
    const [selectedSegments, setSelectedSegments] = useState([])
    const [selectedRatePlans, setSelectedRatePlans] = useState([]);
    const [selectedRateType, setSelectedRateType] = useState('bar_rate');
    const [valueType, setValueType] = useState("add_currency");
    const [baseOnly, setBaseOnly] = useState(false);
    const [baseRoom, setBaseRoom] = useState({})
     const [rateValue, setRateValue] = useState("");
     const [pricingData, setPricingData] = useState([])

    const refreshDataBtnAccess = [0,1,2,3,4,5];
    const [refreshingData, setRefreshingData] = useState(false);
    const [isrequesting, setIsRequesting] = useState(false);

    const navigate = useNavigate();
    const [isShakeButton, setIsShakeButton] = useState(false);
    const [refreshedData, setRefreshedData] = useState(false);
    const [isRequestSuccess, setIsRequestSuccess] = useState(false);
    const [requestSuccessMsg, setRequestSuccessMsg] = useState(
        "Success!"
    );    
    const [resErrorMsg, setResErrorMsg] = useState("");

    const [isRequestError, setIsRequestError] = useState(false);

    const [isChangeRequest, setIsChangeRequest] = useState(false);
    function goBackToDashboard() {
        if (isChangeRequest) {
            setIsShakeButton(true);
            let shakeAlert = document.getElementsByClassName("save-changes-alert");
            if (shakeAlert.length > 0) {
                shakeAlert[0].className = shakeAlert[0].className.replace("display-none", "").trim();
                setTimeout(() => {
                    shakeAlert[0].className += " display-none";
                }, 2000);
            }
            setTimeout(function () {
                setIsShakeButton(false);
            }, 2000); // 3000 milliseconds = 3 seconds
            return;
        }
        dispatch(
            updateAppState("navigate_to_dashboard", {
                app_state: {
                    data_load: true,
                    kpi_load: true,
                },
                ui_state: {
                    active_settings_menu: "",
                    showspinner: true,
                },
            }, "settings_click")
        );
        navigate("/");
    }
    const cancelSave = () => {
        
        setIsChangeRequest(false);
    };
    const saveChanges =()=>{

    }
    function refreshData() {
        if (isChangeRequest) {
            setIsShakeButton(true);
            let shakeAlert = document.getElementsByClassName("save-changes-alert");
            if (shakeAlert.length > 0) {
                shakeAlert[0].className = shakeAlert[0].className.replace("display-none", "").trim();
                setTimeout(() => {
                    shakeAlert[0].className += " display-none";
                }, 2000);
            }
            setTimeout(function () {
                setIsShakeButton(false);
            }, 2000); // 3000 milliseconds = 3 seconds
            return;
        }
        cleanIDB();
        //reverting changes back
        setIsChangeRequest(false);

        const payload = {
            token_string: user.token_string,
            resourceId: app_state.property_id,
            resourceType: "property",
            targetCache: ["srr", "forecast", "otb"],
            operation: "flush",
        };
        setRefreshingData(true);
        // debugger;
        dataService.getData({ api: "rms/properties/clear-cache/" + app_state.property_id + "/" + app_state.active_data_src.id + "/", request: { method: 'GET' } })
            .then((data) => {
                //Do some task here just after respons
                if (data.status === "success") {
                    setRefreshedData(true);
                    setRefreshingData(false);
                    console.log("refreshData Success");
                    setTimeout(() => {
                        setRefreshedData(false);
                        // window.location.reload();
                    }, 2000);
                    clearAPIRegistryData();
                } else {
                    setRefreshingData(false);
                    console.warn("refreshData Error, data could not refreshed");
                    setTimeout(() => {
                        setRefreshedData(false);
                    }, 3000);
                }
            })
            .catch((err) => {
                setRefreshingData(false);
                setTimeout(() => {
                    setRefreshedData(false);
                }, 3000);
            });
    }
    const getCurrentData = ()=>{
        setcompState(prev => {return {...prev,  progress:"loading"} });
        const data_sources =["OSRRateRecommend"];
        const mainPromises=[];
        data_sources.forEach(src=>{
            /// call the api with custom date range

          const apiCallStarting = getData365({...app_state, date_from:dateRange.current.date_from, 
            date_until:dateRange.current.date_until,removeCompId:true, customRange:true},src);
          mainPromises.push(apiCallStarting);
        })
        
        Promise.allSettled(mainPromises).then(settled=>{
          const dataArray = settled.map((item, index) => {
              if (item.status === 'fulfilled') {
                  
                  return {...item.value, data_id:data_sources[index]};
              } else {
                  return { data: [], status: 'error', data_id: item.reason.data_id, message: item.reason.message };
              }
          });
          dataArray.forEach((res)=>{
            if(res.status === "success"){
              const finalData = { data: deepCopy(res.data) };
                finalData.data_id = res.data_id;
                finalData.ok = true;
                dataService.updateDataCache(res.data_id , { data: finalData, loaded: true, loading: false});
  
              if(res.data_id === "OSRRateRecommend"){
                // this will get the custom range data format
                
                const PricingData = getPricingDataFormatted({primary_stay_range:dateRange.current, 
                    room_settings:app_state.room_settings}, true,res.data);
                // dispatch({
                //     type: UPDATE_STATE, payload: { 
                //         app_state: { 
                //             primary_stay_range:{
                //                 date_from:dateRange.current.date_from,
                //                 date_until:dateRange.current.date_until,
                //             }
                //         }
                //     }
                // });
                console.log("historicalRange",app_state.historicalRange)
                setcompState(prev => {return {...prev, progress:"loaded"} });
       
                setPricingData(prev=>{
                    return PricingData;
                })
              }
            }
          });
        }).catch(err=>{
          console.log(err);
    
        })
    }
    useEffect(()=>{
        console.log("mounted")
        if(!APP_CACHE.pricingRateModalOpen){
            
            getCurrentData();
        }
       
    },[])
    useEffect(() => {
        let isSubscribed =true;
        console.log("mounted 2")
        // let superTypes = {
        //     // "All":[],
        //   };
        // let categoryList = [];
        let {room_settings} = app_state;
        room_settings.forEach((room, index) => {
            // if (superTypes[room.room_class]) {
            //     superTypes[room.room_class].push(room.room_code)
            // } else {
            //     superTypes[room.room_class] = [room.room_code]
        
            // }
            if(room.is_base){
                setBaseRoom(prev=> room);
            }
            // superTypes["All"].push(room.room_code);
        });
        // Object.keys(superTypes).map(type => {
        //     categoryList.push({ room_class: type, room_codes: superTypes[type] });
        // })
        // setCategoryList(prev=> categoryList);
        // setDataLevel("Hotel")
        if(!APP_CACHE.pricingRateModalOpen){
            setcompState(prev=>{
                return {...prev,entry: {...blankRestriction}, restrictionOpen:false , saveReady:false, modified:false}
            })
    
            setPricingData(prev=> {
                return  getPricingDataFormatted({primary_stay_range:{
                    date_from:moment(app_state.as_of_date).format("YYYY-MM-DD"),
                    date_until:moment().add(59,"days").format("YYYY-MM-DD")
                }, room_settings:app_state.room_settings}, true)
            })
        }
        
        // const rateCodesMapping = dataService.getSeriesById("GetRateCodeMapping").data;
        //   console.log(ui_state);
        //     let segments = getTransformedSegments(market_segment_category_mapping,
        //          market_code_ignorelist);
        //     let codes = Object.keys(segments.map);
        //     let ratePlanCodes = [];
        //     codes.map((code) => {
        //         if (rateCodesMapping && rateCodesMapping["agg"][code]) {
        //             ratePlanCodes = [...ratePlanCodes, ...rateCodesMapping["agg"][code]];
        //         }
        //     });
        //     selectedCalendarDates.current = [];
        //     setSelectedRoomCodes(prev=> []);
        //     setSelectedRoomClasses(prev=> []);
        //     setBaseOnly(false);
        //     setValueType("add_currency");
        //     setRateValue(null);
        //     setSegmentOptions(prev=>{
        //         return [...market_segment_category_order];
        //     })
        //     setRatePlanOptions(prev=>{
        //         return [...ratePlanCodes];
        //     })
            
        // if(property_info.permissions.restrictions ===1){
        //     const options = [{display:"Hotel", value:"Hotel"} ] /// add in the room type properly
          
        //     if(property_info.permissions.restriction_d.restriction_room_type === true ){
        //         options.push({display:"Room Type", value:"RoomType"})
        //     }
        //     if(property_info.permissions.restriction_d.restriction_rate_plan === true ){
               
        //         options.push({display:"Rate Plan", value:"RatePlan"})
        //     }
        //     setDataLvlOptions(prev=>{
                
        //         return [...options ]
        //     })
        // }
        return () => {
            isSubscribed=false;
        }
    }, []);

    const calculateOverrideRate = (previousRate,valueType, rateValue)=>{
        let newRate =0;
        previousRate = (!previousRate || isNaN(previousRate)) ? 0 :previousRate;
        if(previousRate){
            previousRate = parseInt(previousRate);
            rateValue = parseInt(rateValue);
            if(valueType === "add_currency"){
                newRate =  previousRate+rateValue;
            }
            if(valueType === "subtract_currency"){
                newRate =  previousRate-rateValue;
            }
            if(valueType === "add_percent"){
                newRate = previousRate+ Math.round(( rateValue/ 100) * previousRate );
            }
            if(valueType === "subtract_percent"){
                newRate = previousRate - Math.round(( rateValue/ 100) * previousRate );
            }
        }
        if(newRate<0){
            return 0;
        }
        return newRate;
    }
    const handleCancel = ()=>{
        selectedCalendarDates.current = selectedCalendarDates.current.map(item=>{
            item.active = false;
            return item
        });
        setRateValue("");
        setcompState(prev=>{
            return {...prev, modified:false, saveReady:false}
        })
    }
    const handleSavePricing = ()=>{
        console.log(app_state.roomtype_pricing_overrides);
        console.log(selectedCalendarDates);
        console.log(selectedRateType);
        console.log(valueType);
        console.log(rateValue);
        console.log(pricingData);
        console.log(baseRoom)
        const pricingOverride ={};
        APP_CACHE.pricingRateModalOpen =true;
        // let room_codes =[];
        
        // room_codes= room_codes.concat(selectedRoomCodes);
        // if(dataLevel  === "Hotel"){
        //     room_codes = app_state.room_settings.map(i=> {
        //         return i.room_code;
        //     });
        // }
        // console.log(room_codes);
        selectedCalendarDates.current.forEach(item=>{
            let datedata =  pricingData.find(i=> i.stay_date === item.date);
            if(item.active === true ){
                pricingOverride[item.date]={};
                if(!datedata[baseRoom.room_code]){
                    datedata[baseRoom.room_code]={
                        SellRate:0,
                        RecSellRate:0
                    }
                }
                if(selectedRateType === "bar_rate"){
                    pricingOverride[item.date]= {"override_rate":rateValue, approved:true};
                }
                if(selectedRateType=== "rate_modifier"){
                    let previousRate = (datedata[baseRoom.room_code] && datedata[baseRoom.room_code].SellRate) ? datedata[baseRoom.room_code].SellRate : 0;
                    console.log("rate_modifier", previousRate)
                    let newRate = calculateOverrideRate(previousRate, valueType, rateValue)
                    pricingOverride[item.date]= {"override_rate":newRate, approved:true};
                    
                }
                pricingOverride[item.date].previous_data = {
                    RecSellRate:datedata[baseRoom.room_code].RecSellRate,
                    SellRate:datedata[baseRoom.room_code].SellRate,
                    baseRoom:{
                        RecSellRate:datedata[baseRoom.room_code].RecSellRate,
                        SellRate:datedata[baseRoom.room_code].SellRate,
                    }
                }
               
            }
            
        })
        console.log("pricingOverride end", pricingOverride);

        dispatch({
            type: UPDATE_STATE, payload: { 
                app_state: { 
                    
                    pricing_override_rates:{...pricingOverride},
                    bulkPricingSave:true,
                },
                ui_state:{
                    pricingRateModalOpen:true,
                }
            }
        });
        APP_CACHE.pricingRateModalOpen =true;
        // dispatch({
        //     type: UPDATE_STATE, payload: { ui_state: { pricingRateModalOpen: true } }
        // });
    }
    const modifyCalendarDates= (calendarDates)=>{
        console.log("modifyCalendarDates", calendarDates.filter(i=> i.active));
        selectedCalendarDates.current = [...calendarDates.filter(i=> i.active)]
        if(selectedCalendarDates.current.length>0){
            setcompState(state => {
               
                return { ...state, saveReady:true }
            })
        }else {
            setcompState(state => {
               
                return { ...state, saveReady:false }
            })
        }
    }   
    const handleRateTypeChange = (e)=>{
        setSelectedRateType(e.target.value);
    }
    const changeDateRange = (range)=>{
        console.log("changeDateRange");
        dateRange.current = range;
        getCurrentData();
    }
    let pricingSection =(<Box component="section" className="pricing-section" >
    <div className="section-title">Bar Pricing (Hotel)</div>
    <Grid className='restriction-popup-container-1' container >
         <Grid item xs={12} className='bulk-rp-form-box'>
         <RadioGroup
            className='bulk-rp-form-ele'
            row
            
            aria-labelledby="controlled-radio-buttons-group"
            name="controlled-radio-buttons-group"
            value={selectedRateType}
            onChange={handleRateTypeChange}
        >
            <FormControlLabel className={(selectedRateType ==="bar_rate") ? " bulk-rp-form-radio active" : "bulk-rp-form-radio"} value="bar_rate" control={<Radio size="small" />} label="BAR Rate" />
            <FormControlLabel className={(selectedRateType ==="rate_modifier") ? " bulk-rp-form-radio active" : " bulk-rp-form-radio"} value="rate_modifier" control={<Radio size="small" />} label="Rate Modifier" />
        </RadioGroup>
        </Grid>
        
        <Grid item xs={12} className='bulk-rp-form-box'>
            
            <FormControl className='bulk-rp-form-ele' fullWidth>
                
                <label className="input-label" style={{fontSize:"12px"}}>Override Rate</label>
                <TextField className='prefix-ele' size="small" id="value-input"  value={rateValue} variant="outlined" 
                    InputProps={{
                        startAdornment: <InputAdornment position="start">

                            {selectedRateType=== "rate_modifier" && (<Select 
                                className='prefix-ele-select'
                                id="value-type"
                                value={valueType}
                                IconComponent={ExpandMoreIcon}
                                onChange={(e)=>{
                                    setValueType(e.target.value);
                                }}>
                                <MenuItem value={"add_currency"}>{"+"+ui_state.currency_symbol}</MenuItem>
                                <MenuItem value={"subtract_currency"}>{"-"+ui_state.currency_symbol}</MenuItem>
                                <MenuItem value={"add_percent"}>{"+%"}</MenuItem>
                                <MenuItem value={"subtract_percent"}>{"-%"}</MenuItem>
                            </Select>)}

                            {selectedRateType === "bar_rate" && (<span className="prefix-ele-span">{ui_state.currency_symbol }</span>)}

                        </InputAdornment>,
                    }}
                    onChange={(e)=>{                
                        let value = isNaN(parseInt(e.target.value)) ? "" : parseInt(e.target.value);
                        console.log(value);
                        setRateValue(value);
                        if(value !== ""){
                            setcompState(prev=>{
                                return {...prev, modified:true}
                            })
                        }else {
                            setcompState(prev=>{
                                return {...prev, modified:false}
                            })
                        }
                    
                    }} 
                />
            </FormControl>   
        </Grid>
       
        

    </Grid>
    </Box>);

    return (
        <div className="bulk-pricing-section">
            <Box className='top-axn-bar-1 '>
                <Tooltip title="Back to Dashboard" arrow followCursor >
                    <Button
                        size="medium"
                        variant="contained"
                        className='back-to-dash-btn'
                        onClick={goBackToDashboard}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="16.001" height="16.001" viewBox="0 0 16.001 16.001">
                            <g id="Group_2234" data-name="Group 2234" transform="translate(24154 19449)">
                                <path id="Path_3278" data-name="Path 3278" d="M.889,0h8.3a.889.889,0,0,1,.889.889V9.482a.889.889,0,0,1-.889.889H.889A.889.889,0,0,1,0,9.482V.889A.889.889,0,0,1,.889,0Z" transform="translate(-24154 -19449)" fill="#606060" />
                                <g id="Path_3279" data-name="Path 3279" transform="translate(-24142.74 -19449)" fill="#333">
                                    <path d="M 3.852076530456543 4.341016292572021 L 0.8889365196228027 4.341016292572021 C 0.6193365454673767 4.341016292572021 0.3999965190887451 4.121676445007324 0.3999965190887451 3.852076530456543 L 0.3999965190887451 0.8889365196228027 C 0.3999965190887451 0.6193365454673767 0.6193365454673767 0.3999965190887451 0.8889365196228027 0.3999965190887451 L 3.852076530456543 0.3999965190887451 C 4.121676445007324 0.3999965190887451 4.341016292572021 0.6193365454673767 4.341016292572021 0.8889365196228027 L 4.341016292572021 3.852076530456543 C 4.341016292572021 4.121676445007324 4.121676445007324 4.341016292572021 3.852076530456543 4.341016292572021 Z" stroke="none" />
                                    <path d="M 0.8889365196228027 0.7999966144561768 C 0.8398964405059814 0.7999966144561768 0.7999966144561768 0.8398964405059814 0.7999966144561768 0.8889365196228027 L 0.7999966144561768 3.852076530456543 C 0.7999966144561768 3.901116609573364 0.8398964405059814 3.941016674041748 0.8889365196228027 3.941016674041748 L 3.852076530456543 3.941016674041748 C 3.901116609573364 3.941016674041748 3.941016674041748 3.901116609573364 3.941016674041748 3.852076530456543 L 3.941016674041748 0.8889365196228027 C 3.941016674041748 0.8398964405059814 3.901116609573364 0.7999966144561768 3.852076530456543 0.7999966144561768 L 0.8889365196228027 0.7999966144561768 M 0.8889365196228027 -3.337860107421875e-06 L 3.852076530456543 -3.337860107421875e-06 C 4.343016624450684 -3.337860107421875e-06 4.741016387939453 0.3979964256286621 4.741016387939453 0.8889365196228027 L 4.741016387939453 3.852076530456543 C 4.741016387939453 4.343016624450684 4.343016624450684 4.741016387939453 3.852076530456543 4.741016387939453 L 0.8889365196228027 4.741016387939453 C 0.3979964256286621 4.741016387939453 -3.337860107421875e-06 4.343016624450684 -3.337860107421875e-06 3.852076530456543 L -3.337860107421875e-06 0.8889365196228027 C -3.337860107421875e-06 0.3979964256286621 0.3979964256286621 -3.337860107421875e-06 0.8889365196228027 -3.337860107421875e-06 Z" stroke="none" fill="#333" />
                                </g>
                                <g id="Path_3280" data-name="Path 3280" transform="translate(-24142.74 -19443.371)" fill="#333">
                                    <path d="M 3.852076530456543 4.341016292572021 L 0.8889365196228027 4.341016292572021 C 0.6193365454673767 4.341016292572021 0.3999965190887451 4.121676445007324 0.3999965190887451 3.852076530456543 L 0.3999965190887451 0.8889365196228027 C 0.3999965190887451 0.6193365454673767 0.6193365454673767 0.3999965190887451 0.8889365196228027 0.3999965190887451 L 3.852076530456543 0.3999965190887451 C 4.121676445007324 0.3999965190887451 4.341016292572021 0.6193365454673767 4.341016292572021 0.8889365196228027 L 4.341016292572021 3.852076530456543 C 4.341016292572021 4.121676445007324 4.121676445007324 4.341016292572021 3.852076530456543 4.341016292572021 Z" stroke="none" />
                                    <path d="M 0.8889365196228027 0.7999966144561768 C 0.8398964405059814 0.7999966144561768 0.7999966144561768 0.8398964405059814 0.7999966144561768 0.8889365196228027 L 0.7999966144561768 3.852076530456543 C 0.7999966144561768 3.901116609573364 0.8398964405059814 3.941016674041748 0.8889365196228027 3.941016674041748 L 3.852076530456543 3.941016674041748 C 3.901116609573364 3.941016674041748 3.941016674041748 3.901116609573364 3.941016674041748 3.852076530456543 L 3.941016674041748 0.8889365196228027 C 3.941016674041748 0.8398964405059814 3.901116609573364 0.7999966144561768 3.852076530456543 0.7999966144561768 L 0.8889365196228027 0.7999966144561768 M 0.8889365196228027 -3.337860107421875e-06 L 3.852076530456543 -3.337860107421875e-06 C 4.343016624450684 -3.337860107421875e-06 4.741016387939453 0.3979964256286621 4.741016387939453 0.8889365196228027 L 4.741016387939453 3.852076530456543 C 4.741016387939453 4.343016624450684 4.343016624450684 4.741016387939453 3.852076530456543 4.741016387939453 L 0.8889365196228027 4.741016387939453 C 0.3979964256286621 4.741016387939453 -3.337860107421875e-06 4.343016624450684 -3.337860107421875e-06 3.852076530456543 L -3.337860107421875e-06 0.8889365196228027 C -3.337860107421875e-06 0.3979964256286621 0.3979964256286621 -3.337860107421875e-06 0.8889365196228027 -3.337860107421875e-06 Z" stroke="none" fill="#333" />
                                </g>
                                <g id="Path_3283" data-name="Path 3283" transform="translate(-24142.74 -19437.74)" fill="#333">
                                    <path d="M 3.852076530456543 4.341016292572021 L 0.8889365196228027 4.341016292572021 C 0.6193365454673767 4.341016292572021 0.3999965190887451 4.121676445007324 0.3999965190887451 3.852076530456543 L 0.3999965190887451 0.8889365196228027 C 0.3999965190887451 0.6193365454673767 0.6193365454673767 0.3999965190887451 0.8889365196228027 0.3999965190887451 L 3.852076530456543 0.3999965190887451 C 4.121676445007324 0.3999965190887451 4.341016292572021 0.6193365454673767 4.341016292572021 0.8889365196228027 L 4.341016292572021 3.852076530456543 C 4.341016292572021 4.121676445007324 4.121676445007324 4.341016292572021 3.852076530456543 4.341016292572021 Z" stroke="none" />
                                    <path d="M 0.8889365196228027 0.7999966144561768 C 0.8398964405059814 0.7999966144561768 0.7999966144561768 0.8398964405059814 0.7999966144561768 0.8889365196228027 L 0.7999966144561768 3.852076530456543 C 0.7999966144561768 3.901116609573364 0.8398964405059814 3.941016674041748 0.8889365196228027 3.941016674041748 L 3.852076530456543 3.941016674041748 C 3.901116609573364 3.941016674041748 3.941016674041748 3.901116609573364 3.941016674041748 3.852076530456543 L 3.941016674041748 0.8889365196228027 C 3.941016674041748 0.8398964405059814 3.901116609573364 0.7999966144561768 3.852076530456543 0.7999966144561768 L 0.8889365196228027 0.7999966144561768 M 0.8889365196228027 -3.337860107421875e-06 L 3.852076530456543 -3.337860107421875e-06 C 4.343016624450684 -3.337860107421875e-06 4.741016387939453 0.3979964256286621 4.741016387939453 0.8889365196228027 L 4.741016387939453 3.852076530456543 C 4.741016387939453 4.343016624450684 4.343016624450684 4.741016387939453 3.852076530456543 4.741016387939453 L 0.8889365196228027 4.741016387939453 C 0.3979964256286621 4.741016387939453 -3.337860107421875e-06 4.343016624450684 -3.337860107421875e-06 3.852076530456543 L -3.337860107421875e-06 0.8889365196228027 C -3.337860107421875e-06 0.3979964256286621 0.3979964256286621 -3.337860107421875e-06 0.8889365196228027 -3.337860107421875e-06 Z" stroke="none" fill="#333" />
                                </g>
                                <g id="Path_3281" data-name="Path 3281" transform="translate(-24154 -19437.74)" fill="#333">
                                    <path d="M 3.852076530456543 4.341016292572021 L 0.8889365196228027 4.341016292572021 C 0.6193365454673767 4.341016292572021 0.3999965190887451 4.121676445007324 0.3999965190887451 3.852076530456543 L 0.3999965190887451 0.8889365196228027 C 0.3999965190887451 0.6193365454673767 0.6193365454673767 0.3999965190887451 0.8889365196228027 0.3999965190887451 L 3.852076530456543 0.3999965190887451 C 4.121676445007324 0.3999965190887451 4.341016292572021 0.6193365454673767 4.341016292572021 0.8889365196228027 L 4.341016292572021 3.852076530456543 C 4.341016292572021 4.121676445007324 4.121676445007324 4.341016292572021 3.852076530456543 4.341016292572021 Z" stroke="none" />
                                    <path d="M 0.8889365196228027 0.7999966144561768 C 0.8398964405059814 0.7999966144561768 0.7999966144561768 0.8398964405059814 0.7999966144561768 0.8889365196228027 L 0.7999966144561768 3.852076530456543 C 0.7999966144561768 3.901116609573364 0.8398964405059814 3.941016674041748 0.8889365196228027 3.941016674041748 L 3.852076530456543 3.941016674041748 C 3.901116609573364 3.941016674041748 3.941016674041748 3.901116609573364 3.941016674041748 3.852076530456543 L 3.941016674041748 0.8889365196228027 C 3.941016674041748 0.8398964405059814 3.901116609573364 0.7999966144561768 3.852076530456543 0.7999966144561768 L 0.8889365196228027 0.7999966144561768 M 0.8889365196228027 -3.337860107421875e-06 L 3.852076530456543 -3.337860107421875e-06 C 4.343016624450684 -3.337860107421875e-06 4.741016387939453 0.3979964256286621 4.741016387939453 0.8889365196228027 L 4.741016387939453 3.852076530456543 C 4.741016387939453 4.343016624450684 4.343016624450684 4.741016387939453 3.852076530456543 4.741016387939453 L 0.8889365196228027 4.741016387939453 C 0.3979964256286621 4.741016387939453 -3.337860107421875e-06 4.343016624450684 -3.337860107421875e-06 3.852076530456543 L -3.337860107421875e-06 0.8889365196228027 C -3.337860107421875e-06 0.3979964256286621 0.3979964256286621 -3.337860107421875e-06 0.8889365196228027 -3.337860107421875e-06 Z" stroke="none" fill="#333" />
                                </g>
                                <g id="Path_3282" data-name="Path 3282" transform="translate(-24148.369 -19437.74)" fill="#333">
                                    <path d="M 3.852076530456543 4.341016292572021 L 0.8889365196228027 4.341016292572021 C 0.6193365454673767 4.341016292572021 0.3999965190887451 4.121676445007324 0.3999965190887451 3.852076530456543 L 0.3999965190887451 0.8889365196228027 C 0.3999965190887451 0.6193365454673767 0.6193365454673767 0.3999965190887451 0.8889365196228027 0.3999965190887451 L 3.852076530456543 0.3999965190887451 C 4.121676445007324 0.3999965190887451 4.341016292572021 0.6193365454673767 4.341016292572021 0.8889365196228027 L 4.341016292572021 3.852076530456543 C 4.341016292572021 4.121676445007324 4.121676445007324 4.341016292572021 3.852076530456543 4.341016292572021 Z" stroke="none" />
                                    <path d="M 0.8889365196228027 0.7999966144561768 C 0.8398964405059814 0.7999966144561768 0.7999966144561768 0.8398964405059814 0.7999966144561768 0.8889365196228027 L 0.7999966144561768 3.852076530456543 C 0.7999966144561768 3.901116609573364 0.8398964405059814 3.941016674041748 0.8889365196228027 3.941016674041748 L 3.852076530456543 3.941016674041748 C 3.901116609573364 3.941016674041748 3.941016674041748 3.901116609573364 3.941016674041748 3.852076530456543 L 3.941016674041748 0.8889365196228027 C 3.941016674041748 0.8398964405059814 3.901116609573364 0.7999966144561768 3.852076530456543 0.7999966144561768 L 0.8889365196228027 0.7999966144561768 M 0.8889365196228027 -3.337860107421875e-06 L 3.852076530456543 -3.337860107421875e-06 C 4.343016624450684 -3.337860107421875e-06 4.741016387939453 0.3979964256286621 4.741016387939453 0.8889365196228027 L 4.741016387939453 3.852076530456543 C 4.741016387939453 4.343016624450684 4.343016624450684 4.741016387939453 3.852076530456543 4.741016387939453 L 0.8889365196228027 4.741016387939453 C 0.3979964256286621 4.741016387939453 -3.337860107421875e-06 4.343016624450684 -3.337860107421875e-06 3.852076530456543 L -3.337860107421875e-06 0.8889365196228027 C -3.337860107421875e-06 0.3979964256286621 0.3979964256286621 -3.337860107421875e-06 0.8889365196228027 -3.337860107421875e-06 Z" stroke="none" fill="#333" />
                                </g>
                            </g>
                        </svg>
                        <span className='back-to-dash-txt'>Back to Dashboard</span>
                    </Button>
                </Tooltip>

                <Box className={(isShakeButton) ? "top-axn-bar-1-sub bt-shake" : "top-axn-bar-1-sub"}>
                    {refreshDataBtnAccess.includes(user_login_type) &&
                        <Tooltip title="Refresh Data" >
                            <box
                                onClick={refreshData}
                                size="medium"
                                variant="contained"
                                className='refresh-btn'
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" fill="#00415F" viewBox="0 0 256 256"><path d="M240,56v48a8,8,0,0,1-8,8H184a8,8,0,0,1,0-16H211.4L184.81,71.64l-.25-.24a80,80,0,1,0-1.67,114.78,8,8,0,0,1,11,11.63A95.44,95.44,0,0,1,128,224h-1.32A96,96,0,1,1,195.75,60L224,85.8V56a8,8,0,1,1,16,0Z"></path></svg>
                            </box>
                        </Tooltip>
                    }

                    <Button
                              className={(compState.modified && compState.saveReady) ? "navigate-cancel-button btn-active" : "navigate-cancel-button"}

                              variant="outlined"
                              size="small"
                              disabled={!compState.modified || !compState.saveReady}
                              sx={{ minWidth: "auto" }}
                              onClick={handleCancel}
                          >
                              Cancel
                          </Button>

                          {/* <Button
                              disabled={!compState.modified || !compState.saveReady}
                              className={(compState.modified && compState.saveReady) ? "navigate-save-button btn-active" : "navigate-save-button"}
                              variant="outlined"
                              size="small"
                              sx={{ minWidth: "auto", mr: 1, color: "white.main" }}
                              onClick={()=>{
                                  handleSavePricing()
                              }}
                          >
                              Update
                          </Button> */}

                    <Button
                        //disabled={!isChangeRequest}
                        disabled={!compState.modified || !compState.saveReady}
                        className={(compState.modified && compState.saveReady) ? "navigate-save-button btn-active" : "navigate-save-button"}
                             
                        onClick={() => {
                            handleSavePricing();
                        }}
                        variant="outlined"
                        size="small"
                        // className={(isChangeRequest) ? "navigate-save-button btn-active" : "navigate-save-button"}
                        // color="green"
                        sx={{ minWidth: "auto", mr: 1, color: "white.main" }}
                    >
                        <span style={{ display: !isrequesting ? "block" : "none" }}>
                            Update
                        </span>
                        <span
                            style={{
                                display: isrequesting ? "block" : "none",
                                paddingRight: 10,
                            }}
                        >
                            saving...
                        </span>
                        <CircularProgress
                            sx={{ display: isrequesting ? "block" : "none" }}
                            color="white"
                            size="16px"
                        />
                    </Button>
                </Box>

                <Alert
                    icon={false}
                    sx={{
                        display: refreshedData ? "block" : "none",
                        position: "fixed",
                        left: 0,
                        fontSize: 17,
                        textAlign: "center",
                        borderRadius: 0,
                        lineHeight: 1,
                        bottom: 40,
                        width: "100%",
                        zIndex: 100,
                        backgroundColor: "green.main",
                        color: "white.main",
                    }}
                    severity="success"
                >
                    Data refreshed successfully!
                </Alert>

            </Box>

            <Box className='top-axn-bar'>
                <Box className='breadcrumb' sx={{ color: 'white.main' }}>
                    <span className="breadcrum-inactive">Settings</span>
                    <ArrowForwardIosOutlinedIcon className="breadcrum-inactive"
                        sx={{ top: 3, position: "relative", height: 18 }}
                    ></ArrowForwardIosOutlinedIcon>
                    <span className="breadcrum-inactive">Property Settings</span>
                    <ArrowForwardIosOutlinedIcon className="breadcrum-inactive"
                        sx={{ top: 3, position: "relative", height: 18 }}
                    ></ArrowForwardIosOutlinedIcon>
                    <span className="breadcrum-active">Bulk Pricing</span>
                </Box>
            </Box>

            <Box className="bgwhite main-scroll-wrap-inventory" sx={{ pl: 2, pr: 2 }}>
                <div className='profile-heading' style={{ paddingBottom: '10px' }}>
                    Bulk Pricing
                    
                </div>

                <Alert
                    severity="success"
                    sx={{
                        display: isRequestSuccess ? "all" : "none",
                    }}
                >
                    {requestSuccessMsg}
                </Alert>
                <Alert
                    severity="error"
                    sx={{
                        display: isRequestError ? "all" : "none",
                    }}
                >
                    {resErrorMsg}
                </Alert>
                <Alert
                    severity="error"
                    className="save-changes-alert display-none"
                    sx={{ marginTop: "10px" }}
                >
                    {unsavedAlertMsg}
                </Alert>

         
          
            <>
              <Box className='modal-titlebar-res-review-update'>
                  <Grid container spacing={0} className='modal restrictions-update'>
                      
                   
                  </Grid>

              </Box>

              <Box sx={{ height: '100%' }}  className="bulk-popup-body">
                  <Grid container className="bulk-columns-cover">
                      <Grid item style={{width: "320px"}} className='date-range-picker-box'>
                          <div className="section-title">Select dates Range</div>
                          <CustomCalendar asOfDate={app_state.as_of_date}
                              changeDateRange={changeDateRange} 
                              currentCalendarDates={selectedCalendarDates.current}
                              modifyCalendarDates={modifyCalendarDates} />
                      </Grid>
                    
                      <Grid item xs>
                          {pricingSection}
                      </Grid>
                      
                  </Grid>
                  <Box className="bulk-popup-footer">
                      <div className="info-text">
                          To select multiple options, simply hold down the Shift key and click on the Week, Days, or Week Number.
                      </div>
                    
                      
                  </Box>
                  {compState.pushError && (<Stack sx={{ width: '100%', paddingLeft: "16px", paddingRight: "16px",marginBottom:"10px" }} spacing={2}>
                      <Alert severity="warning" sx={{ color: "#333333", background: "rgba(224, 49, 49, 0.10)", pt: "0px", pb: "0px", border: "1px solid #E03131" }}>
                          Something Went Wrong, Please Try Again</Alert>
                  </Stack>)}
              </Box>
              <SendPricingRateBulk/>
              </>



          </Box>
        </div>
    )
}

export default BulkPricingSection
